import { Icon } from "@metsooutotec/modes-react-components"
import { ProvisionType } from "features/provisioning/provisions/models/provision-models"
import styles from "./provision-events-icon.module.css"

const map = {
    [ProvisionType.Commissioned]: <Icon name='icon-ok-circle-16' className={styles.commissioned} />,
    [ProvisionType.Decommissioned]: <Icon name='icon-cross-circle-16' className={styles.decommissioned} />,
    [ProvisionType.Planned]: <Icon name='icon-ok-circle-16' className={styles.planned} />,
}

export function provisionTypeToIcon(type: ProvisionType) {
    return map[type]
}
